"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TelephoneField;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _telephoneInput = _interopRequireDefault(require("@ux/telephone-input"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _libphonenumberJs = _interopRequireWildcard(require("libphonenumber-js"));
var _density = require("@site/pattern-library-utils/density");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FormFieldSet = /*#__PURE__*/(0, _react2.styled)("fieldset")({
  name: "FormFieldSet",
  class: "pl-fuyw5qx"
});
const fallbackCountryData = [{
  countryKey: 'US',
  label: 'United States',
  callingCode: '1'
}, {
  countryKey: 'AC',
  label: 'Ascension Island',
  callingCode: '247'
}]; // Just used when the api does not work, such as in storybook

const intlNumberRegEx = '^\\d{4,20}$';
const intlNumber = new RegExp(intlNumberRegEx);
const inputExp = /^\d+$/;
const getDomain = () => {
  const domain = /([^.]+)\.([^.]+)$/.exec(global.location.hostname);
  return domain?.[0];
};
function TelephoneField({
  id,
  name,
  label,
  dataCy,
  onChange,
  required,
  placeholder,
  requiredText,
  showCountryCode = true,
  ...otherTelInputProps
}) {
  const [countryData, setCountryData] = (0, _react.useState)(showCountryCode ? fallbackCountryData : []);
  const [value, setValue] = (0, _react.useState)({
    callingCode: countryData[0]?.callingCode || '',
    lineNumber: ''
  });
  const [valid, setValid] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    if (!showCountryCode) {
      return;
    }
    let marketId;
    try {
      marketId = global?.cms?.readCookie('market');
    } catch {
      marketId = 'en-US';
    }
    const domain = getDomain();
    if (domain) {
      global.fetch(`https://api.${domain}/v1/countries?marketId=${marketId}`).then(r => r.json()).then(data => setCountryData(data));
    }
  }, [showCountryCode]);
  (0, _react.useEffect)(() => {
    if (value.lineNumber.length === 0) return;
    if (showCountryCode && !inputExp.test(value.lineNumber)) {
      const valueFixed = value.lineNumber.slice(0, -1);
      setValue({
        ...value,
        lineNumber: valueFixed
      });
    }
  }, [value, showCountryCode]);
  const getMaskedValue = unmaskedValue => {
    const asYouType = new _libphonenumberJs.AsYouType('US');
    return asYouType.input(unmaskedValue);
  };
  const getUnmaskedValue = (0, _react.useCallback)(maskedValue => {
    const {
      nationalNumber
    } = (0, _libphonenumberJs.default)(maskedValue, 'US') || {};
    return nationalNumber;
  }, []);
  const setMaskedValue = inputValue => {
    setValue({
      ...inputValue,
      lineNumber: getMaskedValue(inputValue.lineNumber)
    });
  };
  const getValid = (0, _react.useCallback)(inputValue => {
    if (showCountryCode) {
      return intlNumber.test(inputValue);
    }
    const phoneNumber = (0, _libphonenumberJs.default)(inputValue, 'US');
    return Boolean(phoneNumber) && phoneNumber.isValid();
  }, [showCountryCode]);
  const validate = () => {
    setValid(getValid(value.lineNumber));
  };
  const resetValidation = () => {
    setValid(true);
  };
  const handleChange = (0, _react.useCallback)(({
    callingCode,
    lineNumber
  }) => {
    const code = callingCode === '1' ? '' : callingCode;
    onChange && onChange({
      value: `${code}${getUnmaskedValue(lineNumber)}`,
      valid: getValid(lineNumber)
    });
  }, [onChange, getUnmaskedValue, getValid]);
  (0, _react.useEffect)(() => {
    handleChange(value);
  }, [value, valid, handleChange]);
  return /*#__PURE__*/_react.default.createElement(FormFieldSet, null, /*#__PURE__*/_react.default.createElement(_telephoneInput.default, (0, _extends2.default)({
    id: `input-${id}`,
    "data-cy": `${dataCy}`,
    name: name,
    label: label,
    placeholder: placeholder,
    required: required,
    "aria-required": required,
    intlCallingCodes: countryData,
    onChange: v => {
      if (!showCountryCode) {
        setMaskedValue(v);
      } else {
        setValue(v);
      }
    },
    value: value,
    invalid: !valid,
    errorMessage: !valid ? requiredText : '',
    pattern: showCountryCode ? intlNumberRegEx : null,
    onFocus: resetValidation,
    onBlur: validate
  }, otherTelInputProps)));
}
TelephoneField.propTypes = {
  id: _propTypes.default.string,
  required: _propTypes.default.bool,
  requiredText: _propTypes.default.string,
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  name: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  onChange: _propTypes.default.func,
  showCountryCode: _propTypes.default.bool,
  otherTelInputProps: _propTypes.default.shape(_telephoneInput.default.propTypes)
};